function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.625h30v18.75H0V5.625Z",
    style: {
      fill: "#006aa7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.125h9.375v-7.5h3.75v7.5h16.875v3.75H13.125v7.5h-3.75v-7.5H0v-3.75Z",
    style: {
      fill: "#fecc00"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSe);
export default __webpack_public_path__ + "static/media/SE.cf091b51dd7fdd38629048220192120f.svg";
export { ForwardRef as ReactComponent };